import SchemaMarkup from "../Components/SchemaMarkup";

const TestimonialsPageSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",

    "@id": "https://msayurved.com/testimonials/#collectionpage",

    "url": "https://msayurved.com/testimonials/",

    "name": "Patient Testimonials | Dr. Jigar Gor's Ayurveda",

    "description":
      "Read patient testimonials and experiences with Ayurvedic consultations and treatments at Dr. Jigar Gor's Ayurveda Center in Bhuj, Kutch.",

    "isPartOf": {
      "@id": "https://msayurved.com/#website"
    },

    "about": {
      "@id": "https://msayurved.com/#medicalclinic"
    },

    "inLanguage": "en-IN"
  };

  return <SchemaMarkup data={schema} />;
};

export default TestimonialsPageSchema;